/* ── OSCILLA BY NOOR — CUSTOM JS ── */

(function () {
  'use strict';

  // ── 1. INTRO SEQUENCE ──
  function runIntro() {
    if (sessionStorage.getItem('oscilla-intro')) return;
    sessionStorage.setItem('oscilla-intro', '1');
    var overlay = document.createElement('div');
    overlay.style.cssText = [
      'position:fixed','top:0','left:0','width:100%','height:100%',
      'background:#f5f5f3','z-index:9999',
      'display:flex','align-items:center','justify-content:center',
      'transition:opacity 0.6s ease','will-change:opacity'
    ].join(';');
    var metaLogo = document.querySelector('meta[name="oscilla-logo-url"]');
    var logoEl = document.createElement('img');
    logoEl.src = metaLogo ? metaLogo.content : '';
    logoEl.alt = 'oscilla by noor';
    logoEl.style.cssText = 'width:160px;opacity:0;transition:opacity 0.5s ease;display:block;';
    if (!logoEl.src) {
      var t = document.createElement('span');
      t.textContent = 'oscilla';
      t.style.cssText = 'font-family:Helvetica,Arial,sans-serif;font-size:48px;color:#0f0f0f;opacity:0;transition:opacity 0.5s ease;letter-spacing:0.05em;';
      overlay.appendChild(t); logoEl = t;
    } else { overlay.appendChild(logoEl); }
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    setTimeout(function () { logoEl.style.opacity = '1'; }, 300);
    setTimeout(function () { overlay.style.background = '#1a2fff'; }, 900);
    setTimeout(function () { overlay.style.background = '#f0f0ee'; }, 1060);
    setTimeout(function () { overlay.style.background = '#1a2fff'; }, 1200);
    setTimeout(function () { overlay.style.background = '#f0f0ee'; }, 1340);
    setTimeout(function () {
      overlay.style.opacity = '0';
      document.body.style.overflow = '';
      setTimeout(function () { if (overlay.parentNode) overlay.remove(); }, 650);
    }, 1600);
  }

  // ── 2. NAV SCROLL TRACKING ──
  function initNav() {
    var header = document.getElementById('header-component');
    if (!header) return;
    var lastY = window.scrollY;
    function update() {
      var currentY = window.scrollY;
      var delta = currentY - lastY;
      lastY = currentY;
      if (currentY < 10) { header.classList.remove('oscilla-scrolled'); return; }
      if (delta > 0) header.classList.add('oscilla-scrolled');
      else if (delta < 0) header.classList.remove('oscilla-scrolled');
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // ── 3. LOGO ↔ ICON SWAP ──
  function initLogoSwap() {
    var header = document.getElementById('header-component');
    if (!header) return;
    var logoLink = header.querySelector('a[href="/"]');
    if (!logoLink) return;
    var existingLogo = logoLink.querySelector('img, svg');
    if (!existingLogo) return;
    existingLogo.classList.add('oscilla-logo-full');
    var metaIcon = document.querySelector('meta[name="oscilla-icon-url"]');
    if (metaIcon && metaIcon.content) {
      var icon = document.createElement('img');
      icon.src = metaIcon.content;
      icon.alt = 'oscilla';
      icon.className = 'oscilla-logo-icon';
      logoLink.style.position = 'relative';
      logoLink.appendChild(icon);
    }
  }

  // ── 4. SCROLL SNAP — DESKTOP HOMEPAGE ONLY ──
  function initScrollSnap() {
    var mainEl = document.getElementById('MainContent');
    var tmpl = mainEl ? (mainEl.getAttribute('data-template') || '') : '';
    var isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
    if (tmpl !== 'index' || isTouchDevice) return;

    var VH = window.innerHeight;
    var sections = Array.prototype.slice.call(
      document.querySelectorAll('#MainContent > .shopify-section')
    ).filter(function (s) { return s.offsetHeight > VH * 0.3; });
    if (sections.length < 2) return;

    var scrollTimer = null;
    var isAnimating = false;
    var DEBOUNCE = 3000; // 3-second delay before snap — homepage desktop only

    function getSnapTarget() {
      var scrollY = window.scrollY;
      VH = window.innerHeight;
      var pageBottom = Math.max(0, document.body.scrollHeight - VH);
      if (scrollY >= pageBottom - 150) return { el: null, top: pageBottom };
      var snapPoints = sections.map(function (s) { return { el: s, top: s.offsetTop }; });
      snapPoints.push({ el: null, top: pageBottom });
      var best = snapPoints[0];
      var bestDist = Math.abs(scrollY - snapPoints[0].top);
      snapPoints.forEach(function (sp) {
        var dist = Math.abs(scrollY - sp.top);
        if (dist < bestDist) { bestDist = dist; best = sp; }
      });
      if (best.el && best.el.offsetHeight > VH * 1.15) {
        var into = scrollY - best.top;
        if (into > VH * 0.25 && into < best.el.offsetHeight - VH * 0.25) return null;
      }
      return best;
    }

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function smoothScrollTo(targetY, duration) {
      if (isAnimating) return;
      var startY = window.scrollY;
      var diff = targetY - startY;
      if (Math.abs(diff) < 3) return;
      isAnimating = true;
      var startTime = null;
      function step(ts) {
        if (!startTime) startTime = ts;
        var elapsed = ts - startTime;
        var t = Math.min(elapsed / duration, 1);
        window.scrollTo(0, startY + diff * easeInOutCubic(t));
        if (t < 1) requestAnimationFrame(step);
        else { window.scrollTo(0, targetY); isAnimating = false; }
      }
      requestAnimationFrame(step);
    }

    window.addEventListener('scroll', function () {
      if (isAnimating) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var target = getSnapTarget();
        if (target) smoothScrollTo(target.top, 900);
      }, DEBOUNCE);
    }, { passive: true });
  }

  // ── 5. ARCHIVE LINK ──
  function initArchiveLink() {
    document.querySelectorAll('a[href*="noorarchive"]').forEach(function (el) {
      el.setAttribute('target', '_blank');
      el.setAttribute('rel', 'noopener');
    });
  }

  // ── INIT ──
  function init() {
    runIntro();
    initNav();
    initLogoSwap();
    initScrollSnap();
    initArchiveLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
